/* eslint-disable dot-notation */
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const cmsHelpers = {
  formatCMSRawData(data) {
    const result = { navigation: [] };
    const entries = data?.includes?.Entry || [];
    entries.forEach((entry) => {
      const key = (((entry.sys || {}).contentType || {}).sys || {}).id;
      const items = result[key] || [];
      items.push(entry);
      result[key] = items;
    });

    return result;
  },

  formatImperfectionImagesData(data) {
    const result = [];
    const entries = data.items || [];
    entries.forEach((entry) => {
      const { internalName, imperfectionName, imperfectionDescription, xCoordinates, yCoordinates } = entry.fields;
      const description = ((((imperfectionDescription.content || [])[0] || {}).content || [])[0] || {}).value;
      result.push({ [internalName]: { title: imperfectionName, description, xCoordinates, yCoordinates } });
    });

    return result;
  },
  getFooter(footerData) {
    const data = footerData?.sharedFooterComponent;
    if (data) {
      const popularModels = {
        label: data?.popularModelsLinkBlockHeader || '',
        children: data?.popularModelsLinkBlockCollection?.items?.map((item) => ({
          label: item?.text || '',
          href: item?.link || '',
        })),
      };
      const popularCarTypes = {
        label: data?.popularCarTypesBlockLinkHeader || '',
        children: data?.popularCarTypesLinkBlockCollection?.items?.map((item) => ({
          label: item?.text || '',
          href: item?.link || '',
        })),
      };
      const aboutUs = {
        label: data?.aboutUsLinkBlockHeader || '',
        children: data?.aboutUsLinkBlockCollection?.items?.map((item) => ({
          label: item?.text || '',
          href: item?.link || '',
        })),
      };
      const support = {
        label: data?.supportHeader || '',
        children: data?.supportLinkBlockCollection?.items?.map((item) => ({
          label: item?.text || '',
          href: item?.link || '',
        })),
      };

      const followUs = {
        label: data?.followUsLinkBlockHeader || '',
        children: data?.followUsBlockLinkCollection?.items?.map((item) => ({
          label: item?.text || '',
          href: item?.link || '',
        })),
      };

      const licences = documentToReactComponents(data?.description?.json || {});

      const supportContent = {
        title: data?.supportTitle || '',
        description: data?.supportWorkingTime || '',
        button: {
          label: data?.supportTextButton || '',
          icon: data?.supportIconButton?.url ? <img src={data?.supportIconButton?.url} alt="email" /> : null,
        },
        helpModalProps: {
          content: documentToReactComponents(data?.helpModalContent?.json || {}),
        },
      };

      const copyright = data?.copyrightText || '';
      const term = {
        label: data?.termsAndConditions?.text || '',
        href: data?.termsAndConditions?.link || '',
      };
      const policy = {
        label: data?.privaryPolicy?.text || '',
        href: data?.privaryPolicy?.link || '',
      };

      const items = [popularModels, popularCarTypes, aboutUs, support, followUs];
      return { items, licences, supportContent, copyright, term, policy };
    }
    return {};
  },
  getWhyCarma(data) {
    const whyCarmaData = data?.componentWhyCarma;
    if (whyCarmaData) {
      const advantageList = whyCarmaData?.cardListingCollection?.items?.map((e, i) => ({
        logo: e?.icon?.url,
        title: e?.cardTitle,
        description: documentToReactComponents(e?.cardContent?.json),
        id: i,
      }));
      return {
        heading: whyCarmaData.title,
        subHead: documentToReactComponents(whyCarmaData?.description?.json),
        advantageList,
        cta: {
          link: whyCarmaData?.ctaButtonLink,
          label: whyCarmaData?.ctaButtonText,
        },
        isWhite: false,
      };
    }
    return null;
  },
  getMarketingBlock(data) {
    const marketingData = data?.componentMarketingblock2;
    if (marketingData) {
      return {
        img: marketingData?.image?.url,
        title: marketingData?.title,
        CTA: { label: marketingData?.buttonText, href: marketingData?.buttonLink },
      };
    }
    return null;
  },
  getHeroBanner(data) {
    if (data) {
      const heroBannerData = data?.componentHero;
      const searchModalData = heroBannerData?.searchModal;
      return {
        heroBanner: {
          heading: heroBannerData?.title,
          subHead: documentToReactComponents(heroBannerData?.text?.json),
          carImg: heroBannerData?.image?.url,
        },
        findACar: {
          title: searchModalData?.modalTitle,
          buttonLabel: searchModalData?.submitButtonText,
        },
      };
    }
    return {
      heroBanner: {
        heading: '',
        subHead: '',
        carImg: '',
      },
      findACar: {
        title: '',
        buttonLabel: '',
      },
    };
  },
  getCarmaUSP(data) {
    const carmaUSPData = data?.upSellingPoint;
    if (data) {
      return {
        data: [
          { logo: carmaUSPData?.firstIcon?.url, text: carmaUSPData?.firstText },
          { logo: carmaUSPData?.secondIcon?.url, text: carmaUSPData?.secondText },
          { logo: carmaUSPData?.thirdIcon?.url, text: carmaUSPData?.thirdText },
        ],
      };
    }
    return {
      data: [],
    };
  },
  getStaticContent(data) {
    const staticContentData = data?.componentStaticContent;
    if (staticContentData) {
      return {
        heading: staticContentData?.title,
        content: documentToReactComponents(staticContentData?.body?.json),
        logo: staticContentData?.icon?.url,
      };
    }
    return {
      heading: '',
      subHead: null,
      logo: '',
      link: '',
    };
  },
  getTrustPartner(data) {
    const trustPartnerData = data?.componentOurTrustedPartners;
    const logos = trustPartnerData?.logoListingCollection?.items.map((e) => ({ url: e.url, title: e.title }));
    if (trustPartnerData) {
      return {
        heading: trustPartnerData?.header,
        logos,
      };
    }
    return {
      heading: '',
      logos: [],
    };
  },
  getMarketingBlockData(data) {
    if (data) {
      const marketingBlocks = data?.pageLanding?.sectionsCollection?.items?.filter((item) => !!item?.sys?.id);
      return marketingBlocks?.map((item) => ({
        id: item?.sys.id,
        heading: item?.heading,
        subHead: item?.subHeading,
        text: documentToReactComponents(item?.description.json),
        CTA: { label: item?.navigator.text, link: item?.navigator.link },
        imgPath: item?.image.url,
      }));
    }
    return null;
  },
  genPopularCategory(data) {
    const popularCategoryData = data?.popularCategories;
    if (popularCategoryData) {
      return {
        label: popularCategoryData?.title,
        items: popularCategoryData?.content?.items,
      };
    }
    return null;
  },
  genPopularMake(data) {
    const popularMakeData = data?.contentJson?.componentsCollection?.items;
    if (popularMakeData) {
      const images = popularMakeData?.find((e) => e['__typename'] === 'UpSellingPoint');
      const logo = [images?.firstIcon?.url, images?.secondIcon?.url, images?.thirdIcon?.url];
      const navigator = popularMakeData
        ?.filter((e) => e['__typename'] !== 'UpSellingPoint')
        .map((e) => ({ label: e.text, href: e.link }));
      return {
        label: data?.contentJson?.title,
        items: navigator,
        logo,
        button: data?.contentJson?.button,
      };
    }
    return null;
  },

  parseBodyType(data) {
    return data.contentJson?.componentsCollection?.items.map((e) => e.icon);
  },
};

export default cmsHelpers;
